module.exports = __webpack_public_path__ + "static/img/52.a3ad94e.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/Microsoft365Security/52.png
// module id = Yvm0
// module chunks = 1